export default __webpack_public_path__ + "static/media/background.6d2a4481.jpg";